<template>
    <v-navigation-drawer
        id="appDrawer"
        :mini-variant.sync="mini"
        fixed
        :dark="$vuetify.dark"
        app
        v-model="drawer"
        width="260"
    >
        <v-toolbar color="info darken-1" dark flat height="50px">
            <img
                v-bind:src="computeLogo"
                height="36"
                :alt="$t('lang.header.title')"
            />
            <!--v-toolbar-title class="ml-0 pl-3">
        <span class="hidden-sm-and-down">{{ $t('lang.header.title') }}</span>
      </v-toolbar-title-->
        </v-toolbar>
        <vue-perfect-scrollbar
            class="drawer-menu--scroll"
            :settings="scrollSettings"
        >
            <v-list dense expand>
                <template v-for="(item, i) in menuTree">
                    <!--group with subitems-->
                    <v-list-group
                        v-if="item.items"
                        :key="item.name"
                        :group="item.group"
                        :prepend-icon="item.icon"
                        no-action="no-action"
                        :value="item.href && item.href.length > 0"
                    >

                        <v-list-tile slot="activator" ripple="ripple">
                            <v-list-tile-content>
                                <v-list-tile-title>{{

                                   item.title
                                }}
                                  {{

                                    item.href
                                  }}
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <template v-for="(subItem, i) in item.items">
                            <!--sub group-->
                            <v-list-group
                                v-if="subItem.items"
                                :key="subItem.name"
                                :prepend-icon="subItem.icon"
                                :group="subItem.group"
                                no-action="no-action"

                            >
                                <v-list-tile slot="activator" ripple="ripple">
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{
                                            subItem.title
                                        }}</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile
                                    v-for="(grand, i) in subItem.items"
                                    :key="i"
                                    :to="genChildTarget(item, grand)"
                                    :href="grand.href"
                                    ripple="ripple"
                                >
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{
                                            grand.title
                                        }}</v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action v-if="grand.icon">
                                        <v-icon>{{ grand.icon }}</v-icon>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </v-list-group>
                            <!--child item-->
                            <v-list-tile
                                v-else
                                :key="i"
                                :to="genChildTarget(item, subItem)"
                                :href="subItem.href"
                                :disabled="subItem.disabled"
                                :target="subItem.target"
                                ripple="ripple"
                                :class="
                                    subItem.href === '#' + $route.path
                                        ? 'v-list__tile--highlighted'
                                        : ''
                                "
                            >
                                <v-list-tile-content>
                                    <v-list-tile-title
                                        ><span>{{
                                            subItem.title
                                        }}</span></v-list-tile-title
                                    >
                                </v-list-tile-content>
                                <v-list-tile-action v-if="subItem.icon">
                                    <v-icon>{{ subItem.icon }}</v-icon>
                                </v-list-tile-action>
                            </v-list-tile>
                        </template>
                    </v-list-group>
                    <v-subheader v-else-if="item.header" :key="i">{{
                        item.header
                    }}</v-subheader>
                    <v-divider v-else-if="item.divider" :key="i"></v-divider>
                    <!--top-level link-->
                    <v-list-tile
                        v-else
                        :to="!item.href ? { name: item.name } : null"
                        :href="item.href"
                        ripple="ripple"
                        :disabled="item.disabled"
                        :target="item.target"
                        rel="noopener"
                        :key="item.name"
                    >
                        <v-list-tile-action v-if="item.icon">
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>{{
                                item.title
                            }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </template>
            </v-list>
        </vue-perfect-scrollbar>
    </v-navigation-drawer>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { mapGetters } from "vuex";
import menu from "@/api/menu";

export default {
    name: "app-drawer",
    components: {
        VuePerfectScrollbar,
    },
    props: {
        expanded: {
            type: Boolean,
            default: true,
        },
    },
    data: () => ({
        mini: false,
        drawer: true,
        menus: menu,
        scrollSettings: {
            maxScrollbarLength: 160,
        },
    }),
    computed: {
        ...mapGetters("menu", ["menuTree"]),
        computeGroupActive() {
            return true;
        },
        computeLogo() {
          const domain = window.location.hostname
          if (domain.includes("lms-edusmart.")) {
            return "/img/logo-edusmart1.png"
          }
          if (domain.includes("localhost")) {
            return "/img/logo-edusmart1.png"
          }
          // default
          return "/img/logo.png"
        },

        sideToolbarColor() {
            return this.$vuetify.options.extra.sideNav;
        },
    },
    mounted() {
        if (this.$store.state.auth.loggedIn) {
            this.$store.dispatch("menu/getMenus");
        }

        window.getApp.$on("APP_DRAWER_TOGGLED", () => {
            this.drawer = !this.drawer;
        });
    },

    methods: {
        toggleMini() {
          this.mini = !this.mini;
        },
        genChildTarget(item, subItem) {
            if (subItem.href) return;
            if (subItem.component) {
                return {
                    name: subItem.component,
                };
            }
            return { name: `${item.group}/${subItem.name}` };
        },
    },
};
</script>


<style lang="stylus">
// @import '../../node_modules/vuetify/src/stylus/settings/_elevations.styl';
#appDrawer {
    overflow: hidden;

    .drawer-menu--scroll {
        height: calc(100vh - 48px);
        overflow: auto;
    }
}
</style>
